module.exports = __webpack_public_path__ + "static/media/blaster-main.915f2458.jpg";